import React from "react";
import { steps } from "../data/landing";
import { HOW_SECTION_ID } from "../utils/scroll";
import { CTAButton } from "./CTAButton";
import { LeadResponsePanel } from "./LeadResponsePanel";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
export function HowItWorks() {
  return <section id={HOW_SECTION_ID} aria-labelledby="como-funciona-titulo" className="section-pad border-b border-line bg-surface" data-id="element-234" data-mp="3u0v1rsfos6z0">
      <div className="page-container" data-id="element-235" data-mp="qj3eusgeqd7o">
        <Reveal data-id="element-236" data-mp="qi1qxnealw8j">
          <SectionHeader number="04" label="Cómo funciona" titleId="como-funciona-titulo" title={<>
                Primero encontramos la fuga.{" "}
                <span className="text-gold" data-id="element-238" data-mp="grgxsfhe1jx0">Después instalamos la solución.</span>
              </>} data-id="element-237" data-mp="qil9n6broonm" />
        </Reveal>

        <ol className="relative ml-[7px] mt-12 border-l border-gold/40 md:ml-0 md:grid md:grid-cols-4 md:border-l-0" data-id="element-239" data-mp="19adzwszgbvrn">
          <span className="absolute left-0 right-0 top-[7px] hidden h-px bg-gold/40 md:block" aria-hidden="true" data-id="element-240" data-mp="2rmpj2a72kptb" />
          {steps.map((step, i) => <li key={step.title} className="relative pb-12 pl-9 last:pb-0 md:pb-0 md:pl-0 md:pr-8" data-id="element-241" data-mp="31bqy9y5sj368" data-mpi={i}>
              <Reveal delay={i * STAGGER} data-id="element-242" data-mp="2wkhg1imkn24d">
                <span className="absolute -left-[8px] top-0 h-[15px] w-[15px] rounded-full border border-gold bg-surface md:relative md:left-0 md:block" aria-hidden="true" data-id="element-243" data-mp="2wio3xnt6vpoz">
                  <span className="absolute inset-[4px] rounded-full bg-gold" data-id="element-244" data-mp="3ka3bbuztox73" />
                </span>
                <p className="eyebrow md:mt-8" data-id="element-245" data-mp="3fbib3vkkmdin">Paso {String(i + 1).padStart(2, "0")}</p>
                <h3 className="h3-item mt-4" data-id="element-246" data-mp="1pwarb7jyhpku">{step.title}</h3>
                <p className="body-copy mt-3" data-id="element-247" data-mp="1pwu7ojtyk5wr">{step.body}</p>
              </Reveal>
            </li>)}
        </ol>

        {/* Mobile: compact live-feed version of the hero panel */}
        <Reveal className="mt-10 md:hidden" data-id="element-248" data-mp="3l0s7fvmorvwy">
          <LeadResponsePanel variant="compact" data-id="element-249" data-mp="3pyk412ya067h" />
        </Reveal>

        <Reveal className="mt-10 border-t border-line pt-8 md:mt-12 md:pt-10" data-id="element-250" data-mp="3pytuern8gfdp">
          <p className="max-w-[62ch] font-ui text-[17px] font-bold leading-snug text-cream md:text-[18px]" data-id="element-251" data-mp="3tzdr5u3w9gzb">
            Si vemos que no somos la solución, te lo decimos y te quedas con el diagnóstico.
          </p>
          <div className="mt-8 md:mt-10" data-id="element-252" data-mp="7sovxmcduu6r">
            <CTAButton source="how" data-id="element-253" data-mp="crs43fnntgiy" />
          </div>
        </Reveal>
      </div>
    </section>;
}